<template>
    <div id="app">
        <header class="title">
            <div
                class="title-left"
                @click="toHome">
                <img
                    src="@/assets/logo.png"
                    class="logo" />
                <span>Paay Prima</span>
            </div>
            <div class="mens">
                <div
                    v-for="(item, index) in menu"
                    :key="index"
                    :style="routeIndex === index ? 'font-weight: bold;' : ''"
                    @click="menuChange(index, item.router)">
                    {{ item.title }}
                </div>
            </div>
        </header>

        <RouterView></RouterView>

        <footer class="footer">© Todos los derechos reservados © Aguila Information, S.A.P.I. de C.V..</footer>
    </div>
</template>

<script>
export default {
    name: 'App',

    data () {
        return {
            routeIndex: 0,
            menu: [
                {
                    title: 'Página Principal',
                    router: '/',
                },
                {
                    title: 'Acerca de Nosotros',
                    router: '/Nosotros',
                },
                {
                    title: 'Eliminar Cuenta',
                    router: '/Cuenta',
                },
                {
                    title: 'Aiso de Privacidad',
                    router: '/privacy',
                },
                {
                    title: 'Términos y Condiciones',
                    router: '/service',
                },
            ],
        };
    },
    created () {
        const path = this.$route.fullPath
        if (path === '/') {
            this.routeIndex = 0;
        } else if (path === '/Nosotros') {
            this.routeIndex = 1;
        } else if (path === '/Cuenta') {
            this.routeIndex = 2;
        } else if (path === '/Acuerdo') {
            this.routeIndex = 3;
        }
    },
    methods: {
        menuChange (index, name) {
            this.routeIndex = index;
            this.$router.push({ path: name });
            this.scrollToTop();
        },
        toHome () {
            this.routeIndex = 0;
            this.$router.push({ path: '/' });
            this.scrollToTop();
        },
        scrollToTop () {
            window.scrollTo({
                top: 0,
                behavior: 'instant',
            });
        },
        toCancelar () {
            this.$router.push({ path: '/Cancelar' });
            this.scrollToTop();
        },
    },
};
</script>

<style scoped>
.title-left {
    display: flex;
    align-items: center;
    font-weight: bold;
    cursor: pointer;
}
.mens {
    display: flex;
    gap: 70px;
    font-size: 16px;
}
.mens div {
    cursor: pointer;
}
.title {
    height: 70px;
    line-height: 70px;
    padding: 0 360px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    font-size: 20px;
    position: sticky;
    top: 0;
    z-index: 9;
    border-bottom: 1px solid #efefef;
}

.footer {
    background: #ff7b00;
    display: flex;
    justify-content: space-around;
    padding: 22px 0;
    font-size: 14px;
    color: #ffffff;
}

.logo {
    width: 44px;
    height: 44px;
    margin-right: 16px;
}

@media (max-width: 768px) {
    .title {
        display: none;
    }
    .footer {
        display: none;
    }
    .Notmex {
        display: none;
    }
}
</style>
